<template>
  <VSnackbar
    v-model="model"
    :color="snackbar.type"
    :timeout="snackbar.timeout"
  >
    <VIcon
      :dark="snackbar.type !== 'warning'"
      class="mr-2 white--text"
      v-text="icon"
    />
    <span
      class="white--text"
      v-text="snackbar.msg"
    />
  </VSnackbar>
</template>

<script>
  // Utilities
  import {
    mapState
  } from 'vuex'

  const ICON_MAP = {
    error: 'far fa-thumbs-down',
    info: 'fas fa-exclamation-circle',
    success: 'far fa-thumbs-up',
    warning: 'fas fa-exclamation-triangle'
  }

  export default {
    data: () => ({
      model: false
    }),

    computed: {
      ...mapState(['snackbar']),
      icon () {
        return ICON_MAP[this.snackbar.type] || 'fas fa-check-square'
      }
    },

    watch: {
      snackbar () {
        this.model = true
      }
    }
  }
</script>
